const AWSconfig = {
  accessKeyId: 'AKIAJWMJAFODWGW23NQA',
  secretAccessKey: '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',
  region: 'us-east-1',
  source: 'golocalrx@ilocalbox.com',
  bucket: 'rpx-dev-ext-images-qr'
};
export default AWSconfig;
//source: 'ayaz.belim@epistic.net',
